<div class="privacy-notice-page">
  <p-toast position="top-right" role="status" aria-live="polite" aria-atomic="true"></p-toast>

  <p-card styleClass="privacy-notice-card">
    <div class="privacy-notice-header">
      <p class="eyebrow">Informativa Privacy</p>
      <h1>Informativa privacy AXA</h1>
    </div>

    <div class="privacy-notice-body">
      <p>
        Le società del Gruppo AXA Italia rispettano le persone con le quali entrano in contatto e trattano con cura i Dati Personali utilizzati per lo svolgimento delle proprie attività.
      </p>
      <p>
        A conferma di questo impegno e per dare esecuzione alle norme che tutelano il Trattamento dei Dati Personali forniamo qui di seguito le informazioni essenziali che permettono di esercitare agevolmente ed in modo consapevole i diritti previsti dalla vigente normativa.
      </p>

      <section>
        <h2>Chi decide perché e come trattare i dati?</h2>
        <p>Titolare/i del trattamento dei suoi dati personali in relazione alle finalità indicate nella presente informativa è/sono:</p>
        <ul>
          <li>AXA Assicurazioni S.p.A. con sede legale in Corso Como 17 – 20154 Milano;</li>
          <li>AXA MPS Assicurazioni Danni S.p.A. con sede legale in Via Aldo Fabrizi n. 9 - 00128 Roma;</li>
          <li>AXA Italia Servizi S.c.p.A. con sede legale in Corso Como 17 – 20154 Milano (MI);</li>
          <li>QUIXA Assicurazioni S.p.A. con sede legale in Corso Como 17 – 20154 Milano (MI);</li>
          <li>NOBIS Compagnia di Assicurazioni S.p.A con sede in viale Colleoni 21 – 20864 Agrate Brianza (MB).</li>
        </ul>
        <p>(di seguito, semplicemente "AXA").</p>
        <p>
          Il Responsabile della Protezione di Dati (DPO) può essere contattato direttamente presso la sede legale del Titolare o all'indirizzo e-mail:
        </p>
        <ul>
          <li><a href="mailto:privacy@axa.it">privacy@axa.it</a> per AXA Assicurazioni S.p.A., AXA MPS Assicurazioni Danni S.p.A., QUIXA Assicurazioni S.p.A.;</li>
          <li><a href="mailto:dpo@nobis.it">dpo@nobis.it</a> per NOBIS Compagnia di Assicurazioni S.p.A.</li>
        </ul>
      </section>

      <section>
        <h2>Per quali scopi e su quali basi i dati sono trattati?</h2>
        <p>I Dati Personali sono trattati per:</p>
        <ul>
          <li>valutare l'idoneità del fornitore in relazione agli standard AXA;</li>
          <li>gestire le relazioni con i fornitori e le attività concernenti i contratti di fornitura di servizi o beni a favore del Gruppo AXA Italia, tra cui a titolo meramente esemplificativo la partecipazione a gare, la negoziazione, la gestione del Contratto;</li>
          <li>adempiere gli obblighi di natura amministrativa e contabili previsti dalle leggi vigenti in materia, oltre che gli ulteriori obblighi specificamente previsti a carico del Titolare (es. in materia di contrasto al finanziamento al terrorismo, sanzioni ed embarghi internazionali);</li>
          <li>svolgere verifiche sul corretto adempimento delle prestazioni contrattuali e analisi riguardanti il rendimento professionale.</li>
        </ul>
        <p>
          Il Trattamento dei Dati Personali è necessario per l'esecuzione di attività precontrattuali, per l'esecuzione dei contratti con AXA e per adempiere ad obblighi di legge, nonché per il perseguimento del legittimo interesse del Titolare del trattamento. Nel perseguire il legittimo interesse, AXA ha avuto cura di verificare che siano adeguatamente tutelati gli interessi o i diritti e le libertà fondamentali degli interessati. Per maggiori informazioni, è sempre possibile contattare il DPO di AXA e visitare la sezione dedicata al legittimo interesse, presente sul sito del Titolare, all'interno dell'area privacy. La raccolta dei suoi Dati Personali è quindi necessaria e, in mancanza, non sarà possibile instaurare o proseguire la relazione con AXA.
        </p>
      </section>

      <section>
        <h2>A chi sono comunicati i dati?</h2>
        <p>
          Per il conseguimento delle finalità sopra indicate, i dati personali possono essere comunicati a specifiche categorie di destinatari, tra cui dipendenti, collaboratori e altre Società del Gruppo AXA; fornitori di AXA (es. Provider di applicativi informatici, società di consulenza, ecc.) in qualità di Responsabili del Trattamento; altri soggetti, pubblici o privati, quali il Ministero dell'Economia e delle Finanze (Agenzia delle Entrate), Unità di Informazione Finanziaria (UIF) o concessionarie per la riscossione dei tributi, nei confronti dei quali la comunicazione dei Dati è obbligatoria e che agiscono quali Titolari autonomi del trattamento. I suoi Dati Personali non verranno in nessun caso diffusi a terzi indeterminati, fatta salva la pubblicazione sul sito web del Titolare della ragione sociale delle carrozzerie convenzionate.
        </p>
        <p>
          Per talune attività AXA si avvale di soggetti terzi, operanti talvolta anche al di fuori dell'Unione Europea (es. India, USA). In ogni caso il trasferimento dei dati fuori dall'Unione Europea avviene sulla base delle garanzie previste dalla vigente normativa, tra cui l'utilizzo di regole aziendali vincolanti (cd. Binding Corporate Rules - <a href="https://www.axa.it/privacy" target="_blank" rel="noopener">www.axa.it/privacy</a> nella sezione "Ulteriore documentazione") per i trasferimenti all'interno del Gruppo AXA e l'applicazione di clausole contrattuali standard o la verifica della presenza di una decisione di adeguatezza da parte della Commissione Europea per i trasferimenti extra UE verso società non appartenenti al Gruppo AXA.
        </p>
        <p>
          Per maggiori informazioni sui soggetti cui vengono comunicati i suoi dati personali è sempre possibile contattare AXA, c.a. Data Protection Officer (DPO).
        </p>
      </section>

      <section>
        <h2>Da dove vengono i dati trattati?</h2>
        <p>
          I Dati sono raccolti direttamente presso l'Interessato o raccolti da fonti pubbliche (elenchi, registri, informazioni pubbliche, banche dati legittimamente accessibili, tra cui quelle raccolte tramite siti web e social media), nonché acquisiti da altri soggetti terzi (tra cui, ad esempio, società del Gruppo AXA, società di servizi alle aziende, ecc.), anche mediante la consultazione di banche Dati.
        </p>
        <p>
          Trattiamo solo i dati personali strettamente necessari per il raggiungimento delle finalità sopra indicate.
        </p>
      </section>

      <section>
        <h2>Per quanto tempo i dati vengono conservati?</h2>
        <p>I dati personali sono conservati per tutto il tempo necessario alla gestione del rapporto contrattuale e in ogni caso:</p>
        <ul>
          <li>fino a 20 anni dalla cessazione del rapporto contrattuale, in relazione al legittimo interesse del Titolare;</li>
          <li>fino a 2 anni dalla raccolta dei dati, per le candidature non andate a buon fine al fine di consentire eventuali rivalutazioni rispetto all'inserimento in Albo fornitori.</li>
        </ul>
        <p>Decorso tale periodo, si procede alla loro cancellazione.</p>
      </section>

      <section>
        <h2>Quali sono i diritti dell'interessato e come possono essere esercitati?</h2>
        <p>
          Lei ha il diritto di accedere ai dati personali, farli aggiornare, integrare, rettificare o cancellare, di chiederne la limitazione e di opporsi al loro trattamento, richiedere la portabilità dei dati e, ove applicabile, per il processo di decisione automatizzata, ottenere l'intervento umano da parte del titolare del trattamento, esprimere la propria opinione e contestare la decisione. La normativa prevede anche le ipotesi in cui l'interessato può far valere il proprio diritto all'oblio salvi i casi in cui il trattamento resta comunque necessario.
        </p>
        <p>Per l'esercizio dei diritti, può rivolgersi a:</p>
        <ul>
          <li><a href="mailto:privacy@axa.it">privacy@axa.it</a> per le società AXA Assicurazioni S.p.A., AXA MPS Assicurazioni Vita S.p.A., AXA MPS Assicurazioni Danni S.p.A., AXA Italia Servizi S.c.p.A.;</li>
          <li><a href="mailto:centrocompetenzaprivacy@quixa.it">centrocompetenzaprivacy@quixa.it</a> per la società QUIXA Assicurazioni S.p.A.;</li>
          <li><a href="mailto:privacy@nobis.it">privacy@nobis.it</a> per Nobis Compagnia di Assicurazioni S.p.A.</li>
        </ul>
        <p>
          Inoltre, potrà proporre reclamo all'Autorità di controllo in materia di protezione dei dati personali, rivolgendosi al Garante per la protezione dei dati personali: Piazza Venezia n. 11 - 00187 Roma (+39) 06.696771; <a href="mailto:protocollo@pec.gpdp.it">protocollo@pec.gpdp.it</a>.
        </p>
      </section>
    </div>

    @if (!isPublicView()) {
      <div class="privacy-notice-actions">
        <div class="checkbox-row">
          <p-checkbox
            inputId="privacy-acceptance"
            [binary]="true"
            [ngModel]="accepted()"
            (ngModelChange)="accepted.set(!!$event)"
          ></p-checkbox>
          <label for="privacy-acceptance">Ho preso visione dell'informativa privacy AXA</label>
        </div>

        <button
          pButton
          type="button"
          label="Conferma e prosegui"
          [disabled]="!accepted()"
          [loading]="isSubmitting()"
          (click)="onConfirm()"
        ></button>
      </div>
    }

    <div class="privacy-notice-secondary-actions">
      <button
        pButton
        type="button"
        label="Torna ad area personale"
        severity="secondary"
        [outlined]="true"
        (click)="goHome()"
      ></button>
    </div>
  </p-card>
</div>
